var map = {
	"./logo_3M.png": "c533",
	"./logo_abbott.png": "71ae",
	"./logo_abbvie.png": "e388",
	"./logo_abdi_ibrahim.png": "cba5",
	"./logo_abfen_farma.png": "47dc",
	"./logo_ablynx.png": "18ad",
	"./logo_acadia_pharmaceuticals.png": "0f7a",
	"./logo_accord_farma.png": "3722",
	"./logo_acella_pharmaceuticals.png": "4b2c",
	"./logo_achaogen.png": "e5ec",
	"./logo_acrotech_biopharma.png": "757c",
	"./logo_actavis.png": "5fbb",
	"./logo_actavis_ori.png": "be16",
	"./logo_actelion.png": "4b61",
	"./logo_adeka.png": "e6cb",
	"./logo_advaita.png": "3d87",
	"./logo_advanced_accelerator_applications.png": "bda6",
	"./logo_aegerion_pharmaceuticals.png": "43ad",
	"./logo_aeterna_zentaris.png": "5b48",
	"./logo_agios_pharmaceuticals.png": "40a9",
	"./logo_agp_pharma.png": "6ebad",
	"./logo_ajanta_pharma.png": "4d9e",
	"./logo_akcea_therapeutics.png": "5bfa",
	"./logo_akorn_pharmaceuticals.png": "9c87",
	"./logo_alcon_laboratories.png": "c828",
	"./logo_alembic_pharmaceuticals.png": "4672",
	"./logo_alexion_pharmaceuticals.png": "31ef",
	"./logo_alfa_medical.png": "d967",
	"./logo_alfasigma.png": "7bc5",
	"./logo_alkem.png": "4d7c",
	"./logo_allen.png": "1b46",
	"./logo_allergan.png": "3868",
	"./logo_allison_medical.png": "e4c4",
	"./logo_allos_therapeutics.png": "edb3",
	"./logo_almatica_pharma.png": "84fd",
	"./logo_asofarma.png": "5ea4",
	"./logo_boehringer.png": "34f1",
	"./logo_bristol.png": "d5a0",
	"./logo_celgene.png": "76bf",
	"./logo_dova_pharmaceuticals.png": "2073",
	"./logo_grupo_menarini.png": "3797",
	"./logo_novartis.png": "4313",
	"./logo_pierre.jpg": "9716",
	"./logo_sanofi.png": "844e",
	"./logo_ultra.jpg": "ca52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "868b";